import { Resource } from "i18next";
import { ptBrTranslations } from "./pt-br";

export enum TranslationsOptions {
    pt = "pt-BR",
    en = "en-US",
}

const Translations: Resource = {
    [TranslationsOptions.pt]: ptBrTranslations,
};

export default Translations;
